import * as React from 'react';
import { InverseBg } from './types';
import { InverseBgContext } from './InverseBgContext';
import classNames from 'classnames';
import { getInverseBgClass } from './useInverseBg';

type Props = React.PropsWithChildren<InverseBg>;

export const InverseBgProvider: React.FC<Props> = ({ children, ...props }) => {
  return (
    <InverseBgContext.Provider value={props}>
      {React.Children.map(children, (child: any) => {
        if (typeof child === 'string' || typeof child === 'number') {
          return child;
        }
        return (
          child &&
          React.cloneElement(child, {
            className: classNames(
              child.props.className,
              getInverseBgClass(props.inverse)
            ),
          })
        );
      })}
    </InverseBgContext.Provider>
  );
};
